import { Box, OutlinedInput, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const OneTimeCodeTextField = ({ fieldsPrefix }) => {
  const {
    setValue,
    watch,
    control,
    formState: { errors },
  } = useFormContext();

  const values = watch();

  const oneTimeCodeFields = Object.keys(values || {}).filter(name =>
    name.startsWith(fieldsPrefix)
  );

  useEffect(() => {
    document.addEventListener('paste', handlePasteClipboard);
    return () => document.removeEventListener('paste', handlePasteClipboard);
  }, []);

  const handlePasteClipboard = event => {
    let data = event?.clipboardData?.getData('Text') || '';

    data = data.split('');

    [].forEach.call(
      document.querySelectorAll(`#field-${fieldsPrefix}`),
      (node, index) => {
        node.value = data[index];
        const fieldIndex = `${fieldsPrefix}${index + 1}`;
        setValue(fieldIndex, data[index]);
      }
    );
  };

  const handleChangeWithNextField = (event, handleChange) => {
    const { maxLength, value, name } = event.target;

    const fieldIndex = Number(name.replace(fieldsPrefix, ''));

    if (value.length >= maxLength) {
      if (fieldIndex < oneTimeCodeFields.length) {
        const nextfield = document.querySelector(
          `input[name=${fieldsPrefix}${fieldIndex + 1}]`
        );
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }

    handleChange(event);
  };

  const handleOnKeyDown = event => {
    const { code } = event;
    const { name } = event.target;

    const fieldIndex = Number(name.replace(fieldsPrefix, ''));

    switch (code) {
      case 'Backspace':
        if (fieldIndex > 0) {
          setValue(name, '');
          const prevField = document.querySelector(
            `input[name=${fieldsPrefix}${fieldIndex - 1}]`
          );
          if (prevField !== null) {
            event.preventDefault();
            prevField.focus();
          }
        }
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Stack direction="row" spacing={2} justifyContent="center">
        {oneTimeCodeFields.map((name, index) => (
          <Controller
            key={name}
            name={`${fieldsPrefix}${index + 1}`}
            control={control}
            render={({ field }) => (
              <OutlinedInput
                {...field}
                id={`field-${fieldsPrefix}`}
                autoFocus={index === 0}
                autoComplete="one-time-code"
                placeholder="-"
                onChange={event =>
                  handleChangeWithNextField(event, field.onChange)
                }
                onKeyDown={handleOnKeyDown}
                inputProps={{
                  maxLength: 1,
                  sx: {
                    p: 0,
                    textAlign: 'center',
                    width: { xs: 36, sm: 56 },
                    height: { xs: 36, sm: 56 },
                  },
                }}
              />
            )}
          />
        ))}
      </Stack>

      {!!Object.keys(errors).find(name => name.startsWith(fieldsPrefix)) && (
        <Box sx={{ textAlign: 'center', mt: 1, mr: 2, ml: 2 }}>
          <Typography variant="caption" sx={{ color: 'error.main' }}>
            {
              Object.entries(errors).find(([key]) =>
                key.startsWith(fieldsPrefix)
              )?.[1]?.message
            }
          </Typography>
        </Box>
      )}
    </div>
  );
};

OneTimeCodeTextField.propTypes = {
  fieldsPrefix: PropTypes.string.isRequired,
};

export { OneTimeCodeTextField };
